import { Trans } from '@lingui/react/macro';

import { useLocalizedFormatDate } from '@/modules/claims/freeClaims/state';

interface Props {
  perioChartExamDate?: string | null;
}

export const PerioChartText = ({ perioChartExamDate }: Props) => {
  const formatDate = useLocalizedFormatDate();

  return perioChartExamDate ? (
    <p className="vai-text-sm vai-font-normal vai-text-gray-400">
      <Trans>Based on perio chart from</Trans> {formatDate(perioChartExamDate)}
    </p>
  ) : (
    <p className="vai-text-sm vai-font-normal vai-text-gray-400">
      <Trans>Based only on RBL data</Trans>
    </p>
  );
};
